import React from 'react'
import styled from 'styled-components'
import GridArea from 'templates/Layout/GridArea'

export const StyledComponent = styled(
  ({...rest}) => <GridArea name={'user'} {...rest} />
)`
  position: relative;
  display: flex;
  flex-flow: row nowrap;
  justify-self: flex-end;
  align-self: center;
 `

const _PageHeader_User_Wrapper = (props) => <StyledComponent {...props} />
_PageHeader_User_Wrapper.propTypes = {}
_PageHeader_User_Wrapper.className = StyledComponent

export default _PageHeader_User_Wrapper

